import { WDD } from '../core/wdd.js';

export function buyButton() {
    const addToBasket = async function (e) {
        e.preventDefault();
        const button = e.currentTarget.closest(".jsBuy");
        if (!button || button.classList.contains("bp-button--adding")) return;
        if (!button.dataset.oid) return console.error("Product ID not found in the button data-oid attribute.");
        button.classList.add("bp-button--adding");

        // Getting the product ID from data-oid
        const productId = button.dataset.oid;
        let productsSuccess = undefined;
        let data = {
            "Items": [{
                "CommodityId": productId,
                "Count": 1
            }]
        };
        if (button.dataset.voucher) data["VoucherCode"] = button.dataset.voucher;
        data = JSON.stringify(data);

        // Function to send product to basket
        const sendProductToBasket = async () => {
            try {
                const response = await fetch('/api/basket/v1/items', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8'
                    },
                    body: data
                });

                if (response.ok) {
                    console.info("Product successfully inserted into the basket.");
                    productsSuccess = true;
                } else {
                    console.error("Product failed to insert in the basket.");
                    productsSuccess = false;
                }
            } catch (error) {
                console.error("Error during the request:", error);
                productsSuccess = false;
            } finally {
                evaluateResult();
            }
        };

        // Evaluating results of inserting products and vouchers API calls
        const evaluateResult = () => {
            if (productsSuccess) {
                window.location.href = "/Order1.htm"
            } else {
                window.location.href = button.getAttribute("href");
            }
            setTimeout(() => button.classList.remove("bp-button--adding"), 500);
        };

        await sendProductToBasket();
    };

    // Attach event listeners to all .jsBuy buttons
    WDD.el.querySelectorAll(".jsBuy").forEach(button => {
        button.addEventListener("click", addToBasket);
    });
}